import { render, staticRenderFns } from "./Agent12MonthsSalesNumberDisplayer.vue?vue&type=template&id=473631d2"
import script from "./Agent12MonthsSalesNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./Agent12MonthsSalesNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports